import { isValidSourceUrl } from '../uikit/lib/sourceUrlValidation';

// COM-640 Task 3: pure validation for the rebuilt AddSourceDialog.tsx.
//
// `name` is deliberately absent from both the input's required fields and
// the output shape - the Jira AC and Confluence both say the name is
// optional, but today's dialog (AddSourceDialog.tsx:26, being replaced by
// this module) refuses to submit without one. There is nothing to validate
// about an optional free-text field beyond "it exists or it doesn't", so no
// `nameError` is returned at all - only `urlError`.
//
// `url` is required and validated by the existing `isValidSourceUrl`
// (uikit/lib/sourceUrlValidation.ts), which the OLD dialog's bare
// `new URL()` check did not enforce: http/https only, and a dotted
// hostname - so `http://localhost` is rejected here as a deliberate
// decision (see this module's own test file), not an oversight carried over
// from the stricter check.
export interface AddSourceFormInput {
  name: string;
  url: string;
}

export interface AddSourceFormResult {
  urlError: string | null;
}

export function validateAddSource({ url }: AddSourceFormInput): AddSourceFormResult {
  const trimmedUrl = url.trim();

  if (!trimmedUrl) {
    return { urlError: 'URL is required' };
  }

  if (!isValidSourceUrl(trimmedUrl)) {
    return { urlError: 'Please enter a valid URL (e.g., https://example.com)' };
  }

  return { urlError: null };
}
